import React from 'react';

export type TabType = 'policies' | 'ai-bot';

interface MobileTabsProps {
  activeTab: TabType;
  onTabChange: (tab: TabType) => void;
}

const MobileTabs: React.FC<MobileTabsProps> = ({ activeTab, onTabChange }) => {
  const tabs = [
    { id: 'policies' as TabType, label: 'All policies' },
    { id: 'ai-bot' as TabType, label: 'AI Pal' }
  ];

  return (
    <div className="fixed top-16 left-0 right-0 z-40 bg-white border-b h-12" style={{ borderColor: 'var(--card-shadow)' }}>
      <div className="flex h-full">
        {tabs.map((tab) => (
          <button
            key={tab.id}
            onClick={() => onTabChange(tab.id)}
            className={`flex-1 flex items-center justify-center text-sm font-medium transition-colors relative ${
              activeTab === tab.id
                ? 'text-gray-900'
                : 'text-gray-500 hover:text-gray-700'
            }`}
            style={{ color: activeTab === tab.id ? 'var(--charcoal)' : 'var(--medium-gray)' }}
          >
            {tab.label}
            {activeTab === tab.id && (
              <div className="absolute bottom-0 left-0 right-0 h-0.5 rounded-full" style={{ backgroundColor: 'var(--charcoal)' }} />
            )}
          </button>
        ))}
      </div>
    </div>
  );
};

export default MobileTabs;
